import { Paths } from 'src/constants/paths'

import {
  buildAuth0LogoutUrl,
  getAuth0LogoutConfigFromEnv,
  type Auth0LogoutConfig,
} from './buildAuth0LogoutUrl'

/**
 * Cognitoの`/logout`に渡す戻り先URLを決める。
 *
 * Amplifyの`redirectSignOut`と`signOut({ oauth: { redirectUrl } })`の両方でこの関数を使うこと。
 * Amplifyは`redirectUrl`を`redirectSignOut`配列との完全一致で照合するため、
 * 2箇所に別々の文字列を書くとズレた瞬間に例外になる。
 */
export const getSignOutRedirectUrl = (
  config: Auth0LogoutConfig = getAuth0LogoutConfigFromEnv(),
): string => {
  const path = buildAuth0LogoutUrl(config) ? Paths.LogoutComplete : Paths.Login

  return `${config.webDomain}${path}`
}

/**
 * Amplifyの`redirectSignOut`に渡す許可リスト。
 *
 * `/logout/complete` だけにすると、`/login` 上で呼ばれる引数なしの`signOut()`
 * （`useAuth` / `use-login`）も`/logout/complete`を選んでしまい、ログイン画面を開くだけで
 * Auth0のセッションまで破棄される。`/login`を併せて登録しておくと、`getRedirectUrl`の
 * `isSameOriginAndPathName`が`/login`側を選ぶため余計なAuth0往復が起きない。
 * 明示的なログアウトは`redirectUrl`の完全一致で`/logout/complete`が選ばれる。
 */
export const getSignOutRedirectUrls = (
  config: Auth0LogoutConfig = getAuth0LogoutConfigFromEnv(),
): string[] => {
  const loginUrl = `${config.webDomain}${Paths.Login}`
  const preferred = getSignOutRedirectUrl(config)

  // /login を先頭に置く。`preferredRedirectUrl`を渡す明示的なログアウトは完全一致で選ぶため
  // 順序に依存しないが、引数なし`signOut()`のフォールバック（`isTheSameDomain`）は
  // 先頭要素にマッチするため、将来 /login 以外のページで呼ばれても Auth0 を経由しない。
  return preferred === loginUrl ? [loginUrl] : [loginUrl, preferred]
}
